import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUser } from "@store/slices/userSlice";
import { clearAuthData } from "@utils/auth";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { resetUnauthorizedFlag } from "@config/axios/axios.config";

export const useLogout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [showLogoutModal, setShowLogoutModal] = useState(false);

	const handleLogoutClick = () => {
		setShowLogoutModal(true);
	};

	const handleLogoutConfirm = () => {
		resetUnauthorizedFlag();
		dispatch(clearUser());
		clearAuthData();
		document.title = "Organization Administrator";
		navigate(BROWSER_ROUTES.DASHBOARD);
		setShowLogoutModal(false);
	};

	const handleLogoutCancel = () => {
		setShowLogoutModal(false);
	};

	return {
		handleLogout: handleLogoutClick,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
	};
};
